
import { UIComponentState, UIDataModel, UIComponentHandler } from '../../../toolkit/uicomponent';
import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { APIModelHandler, APIModel } from '../../../toolkit/uicomponentapimodel';

import { APIFeatures } from '../../../../core/util/apifeatures';
import { CRBTUIComponent, CRBTUIComponentProps } from '../crbt/crbtuicomponent';
import { FlashMessageViewImpl } from './flashmessageview';
import { FlashMessageAPIModel, FlashMessageAPIModelImpl } from './flashmessageapimodel';
import { FlashMessageCSSStyleImpl } from './flashmessagecss';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { FlashMessageDto, FlashMessageDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/flashmessage/get/flashmessagedto';



export interface FlashMessageComponentProps extends CRBTUIComponentProps
{
  
}

export interface FlashMessageComponentState extends UIComponentState
{
  
}

export interface FlashMessageComponentHandler extends UIComponentHandler
{
  
}

export class FlashMessageComponent extends CRBTUIComponent<FlashMessageComponentProps, FlashMessageComponentState>
    implements FlashMessageComponentHandler
{
    constructor(props: FlashMessageComponentProps)
    {
        super(props);
        this.state = {isDataNotLoaded:false};
    }

     componentDidMount()
    {
        let map = new Map<string, string>();
        map.set(this.getContext().getResources().getString(Strings.predefined_flash_message), 
        this.getContext().getResources().getString(Strings.predefined_flash_message));

        (this.getView() as FlashMessageViewImpl).setFlashMessageMap(map);
        (this.getView() as FlashMessageViewImpl).showLoader();
        this.getAPIModel().getFlashMessage();

        let defaultFlashDto = new FlashMessageDtoImpl();
        defaultFlashDto.setId("0");

        (this.getView() as FlashMessageViewImpl).setDefaultFlashMessage(
            this.getContext().getResources().getString(Strings.default_flash_message),
        defaultFlashDto);  
    }
  
    componentWillReceiveProps(nextProps: FlashMessageComponentProps)
    {   
        this.getAPIModel().getFlashMessage();
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new FlashMessageViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new FlashMessageCSSStyleImpl(applicationContext);
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new FlashMessageAPIModelImpl(applicationContext, apiModelHandler);
    }

    getAPIModel(): FlashMessageAPIModel
    {
        return (super.getAPIModel() as FlashMessageAPIModel);
    }
    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        console.log("onSuccess: "+ feature + ", " + JSON.stringify(data) );
        
        if(feature === APIFeatures.GET_PREDEFINED_FLASH_MESSAGE)
        {
            (this.getView() as FlashMessageViewImpl).dismissLoader();
            (this.getView() as  FlashMessageViewImpl).updateTabData(this.props.context, 
                this.getContext().getResources().getString(Strings.predefined_flash_message), 
                (data as FlashMessageDto[]));
           
            window.scroll(0, 0);
        }
    }

    
    onFailure(feature: APIFeatures, description: string, data: any)
    {
        if(feature === APIFeatures.GET_PREDEFINED_FLASH_MESSAGE)
        {
            (this.getView() as FlashMessageViewImpl).dismissLoader();
          
            window.scroll(0, 0);
        }
        
       
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/flashmessage/flashmessagecomponent.tsx